export const coinsForOrdersReducer =(state=[],action)=>{
    switch (action.type){
        case 'INIT_COINS_ORDER':
            return [...action.payload]
        default:
            return state
    }
}